(() => {
  const data = document.getElementById('CatalogDisplayLabels');
  if (!data) return;
  let labels; try { labels = JSON.parse(data.textContent); } catch { return; }
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  const extra = {'黃':'Yellow','黑':'Black','白':'White','黑色':'Black','白色':'White','外套尺寸:':'Jacket size:','行動電源顏色:':'Power-bank colour:','外套顏色:':'Jacket colour:'};
  const format = value => labels[value] || (english && (extra[value] || (value.includes(' / ') ? value.split(' / ').map(part => labels[part] || extra[part] || part).join(' / ') : null))) || value;
  window.catalogDisplayLabel = format;
  const selector = '[data-variant-color-label], [data-ss26-card-color], [data-tz-gallery-colour], [data-colour-label], .wv-swatch-selection, .wv-rail-caption, .variant-input label, .cart__item--variants span, [data-alpine-gift-card] select option';
  const sync = root => {
    const nodes = root.matches?.(selector) ? [root] : [];
    nodes.push(...(root.querySelectorAll?.(selector) || []));
    nodes.forEach(node => {
      const raw = node.textContent.trim();
      const productId = node.closest('[data-product-id]')?.dataset.productId || node.closest('[data-id]')?.dataset.id;
      const label = format(window.catalogColourKey?.(raw, productId) || raw);
      if (label !== raw) { node.dataset.nativeLabel = raw; node.textContent = label; }
    });
  };
  sync(document);
  // Native Motion rewrites the selected label after variantChange; format only
  // presentation nodes, including asynchronously inserted QuickShop content.
  new MutationObserver(records => records.forEach(record => {
    const target = record.target.nodeType === 3 ? record.target.parentElement : record.target;
    const label = target?.closest?.(selector);
    if (label) sync(label);
    if (record.type === 'childList') record.addedNodes.forEach(sync);
  })).observe(document.body, {childList: true, characterData: true, subtree: true});
})();

